export const ISSUE_TYPE_LIST_PATH = '/dashboard/admin/issue-type';

export const EMPTY_ISSUE_TYPE_LIST_FILTERS = {
  accountable_department_id: '',
  category_id: '',
  subcategory_id: '',
  status: 'all',
};

const FILTER_KEYS = ['accountable_department_id', 'category_id', 'subcategory_id'];

export function readIssueTypeListStateFromSearchParams(searchParams) {
  const filters = { ...EMPTY_ISSUE_TYPE_LIST_FILTERS };
  FILTER_KEYS.forEach((key) => {
    filters[key] = String(searchParams.get(key) || '');
  });
  const status = String(searchParams.get('status') || '').trim();
  filters.status = status === 'active' || status === 'inactive' ? status : 'all';
  return { filters };
}

export function hasIssueTypeListParams(searchParams) {
  if (!searchParams) return false;
  const status = String(searchParams.get('status') || '').trim();
  return (
    FILTER_KEYS.some((key) => String(searchParams.get(key) || '').trim() !== '') ||
    status === 'active' ||
    status === 'inactive'
  );
}

export function issueTypeListStateToSearchParams({ filters } = {}) {
  const params = new URLSearchParams();
  FILTER_KEYS.forEach((key) => {
    const value = String(filters?.[key] || '').trim();
    if (value) params.set(key, value);
  });
  const status = String(filters?.status || '').trim();
  if (status === 'active' || status === 'inactive') params.set('status', status);
  return params;
}

export function issueTypeListPath(state) {
  const qs = issueTypeListStateToSearchParams(state).toString();
  return qs ? `${ISSUE_TYPE_LIST_PATH}?${qs}` : ISSUE_TYPE_LIST_PATH;
}

export function getInitialIssueTypeListState() {
  const params = new URLSearchParams(
    typeof window !== 'undefined' ? window.location.search : ''
  );
  if (hasIssueTypeListParams(params)) return readIssueTypeListStateFromSearchParams(params);
  return { filters: { ...EMPTY_ISSUE_TYPE_LIST_FILTERS } };
}

export function issueTypeListBackPath(location) {
  const from = location?.state?.from;
  if (typeof from === 'string') {
    const pathOnly = from.split('?')[0];
    if (pathOnly === ISSUE_TYPE_LIST_PATH) {
      const qs = from.includes('?') ? from.slice(from.indexOf('?') + 1) : '';
      const filters = readIssueTypeListStateFromSearchParams(new URLSearchParams(qs)).filters;
      return issueTypeListPath({ filters });
    }
  }
  return ISSUE_TYPE_LIST_PATH;
}
